var exports = {
  "zr": "x620889e6--3c4713--root",
  "DD": "x620889e6--3c4713--title",
  "Kk": "x620889e6--3c4713--icon",
  "h_": "x620889e6--3c4713--description",
  "M3": "x620889e6--3c4713--contacts",
};

module.exports = exports;
